import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaPaperPlane, FaSearch } from 'react-icons/fa';

const Messages = () => {
    const [selectedChat, setSelectedChat] = useState(0);
    const [message, setMessage] = useState('');

    const conversations = [
        {
            id: 0,
            name: 'Mr. Thompson',
            role: 'Mathematics Tutor',
            lastMessage: 'Great progress on your algebra!',
            time: '2h ago',
            unread: 2,
            avatar: '👨‍🏫'
        },
        {
            id: 1,
            name: 'Dr. Sarah Wilson',
            role: 'Physics Tutor',
            lastMessage: 'Don\'t forget to review mechanics',
            time: '5h ago',
            unread: 0,
            avatar: '👩‍🔬'
        },
        {
            id: 2,
            name: 'Ms. Ahmed',
            role: 'Chemistry Tutor',
            lastMessage: 'See you Friday!',
            time: '1d ago',
            unread: 1,
            avatar: '👩‍🏫'
        }
    ];

    const messages = [
        { sender: 'tutor', text: 'Hi! How are you finding the algebra exercises?', time: '10:30 AM' },
        { sender: 'student', text: 'They\'re challenging but I\'m getting there!', time: '10:32 AM' },
        { sender: 'tutor', text: 'Great progress on your algebra!', time: '10:35 AM' },
        { sender: 'student', text: 'Thank you! Looking forward to our next session.', time: '10:36 AM' }
    ];

    return (
        <div>
            <h1 style={{ fontSize: '1.8rem', fontWeight: 'bold', color: 'var(--color-secondary)', marginBottom: '0.5rem' }}>Messages</h1>
            <p style={{ color: '#666', marginBottom: '2rem' }}>Chat with your tutors</p>

            <div style={{ background: 'white', borderRadius: '12px', border: '1px solid #eee', overflow: 'hidden', height: '600px', display: 'grid', gridTemplateColumns: '350px 1fr' }}>
                {/* Conversations List */}
                <div style={{ borderRight: '1px solid #eee', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ padding: '1rem', borderBottom: '1px solid #eee' }}>
                        <div style={{ position: 'relative' }}>
                            <FaSearch style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#999' }} />
                            <input
                                type="text"
                                placeholder="Search conversations..."
                                style={{
                                    width: '100%',
                                    padding: '0.75rem 0.75rem 0.75rem 2.5rem',
                                    border: '1px solid #ddd',
                                    borderRadius: '8px',
                                    fontSize: '0.9rem'
                                }}
                            />
                        </div>
                    </div>
                    <div style={{ flex: 1, overflowY: 'auto' }}>
                        {conversations.map(conv => (
                            <div
                                key={conv.id}
                                onClick={() => setSelectedChat(conv.id)}
                                style={{
                                    padding: '1rem',
                                    borderBottom: '1px solid #f0f0f0',
                                    background: selectedChat === conv.id ? '#f8f9fa' : 'white',
                                    cursor: 'pointer',
                                    transition: 'background 0.2s'
                                }}
                            >
                                <div style={{ display: 'flex', gap: '1rem', alignItems: 'start' }}>
                                    <div style={{ fontSize: '2rem' }}>{conv.avatar}</div>
                                    <div style={{ flex: 1 }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.25rem' }}>
                                            <div style={{ fontWeight: '600' }}>{conv.name}</div>
                                            <div style={{ fontSize: '0.75rem', color: '#999' }}>{conv.time}</div>
                                        </div>
                                        <div style={{ fontSize: '0.85rem', color: '#999', marginBottom: '0.25rem' }}>{conv.role}</div>
                                        <div style={{ fontSize: '0.9rem', color: '#666', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>
                                                {conv.lastMessage}
                                            </span>
                                            {conv.unread > 0 && (
                                                <span style={{
                                                    background: 'var(--color-primary)',
                                                    color: 'white',
                                                    borderRadius: '10px',
                                                    padding: '2px 6px',
                                                    fontSize: '0.75rem',
                                                    fontWeight: '600',
                                                    marginLeft: '0.5rem'
                                                }}>
                                                    {conv.unread}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Chat Area */}
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    {/* Chat Header */}
                    <div style={{ padding: '1rem 1.5rem', borderBottom: '1px solid #eee', background: '#f8f9fa' }}>
                        <div style={{ fontWeight: '600', fontSize: '1.1rem' }}>{conversations[selectedChat].name}</div>
                        <div style={{ fontSize: '0.85rem', color: '#666' }}>{conversations[selectedChat].role}</div>
                    </div>

                    {/* Messages */}
                    <div style={{ flex: 1, padding: '1.5rem', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                        {messages.map((msg, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: index * 0.1 }}
                                style={{
                                    display: 'flex',
                                    justifyContent: msg.sender === 'student' ? 'flex-end' : 'flex-start'
                                }}
                            >
                                <div style={{ maxWidth: '70%' }}>
                                    <div style={{
                                        padding: '0.75rem 1rem',
                                        borderRadius: '12px',
                                        background: msg.sender === 'student' ? 'var(--color-primary)' : '#f0f0f0',
                                        color: msg.sender === 'student' ? 'white' : '#333'
                                    }}>
                                        {msg.text}
                                    </div>
                                    <div style={{
                                        fontSize: '0.75rem',
                                        color: '#999',
                                        marginTop: '0.25rem',
                                        textAlign: msg.sender === 'student' ? 'right' : 'left'
                                    }}>
                                        {msg.time}
                                    </div>
                                </div>
                            </motion.div>
                        ))}
                    </div>

                    {/* Message Input */}
                    <div style={{ padding: '1rem 1.5rem', borderTop: '1px solid #eee' }}>
                        <div style={{ display: 'flex', gap: '0.75rem' }}>
                            <input
                                type="text"
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                placeholder="Type a message..."
                                style={{
                                    flex: 1,
                                    padding: '0.75rem 1rem',
                                    border: '1px solid #ddd',
                                    borderRadius: '8px',
                                    fontSize: '0.9rem'
                                }}
                            />
                            <button className="button-primary" style={{ padding: '0.75rem 1.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                <FaPaperPlane /> Send
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Messages;
